import { createForm } from '@codeleap/common'
import { I18N } from '../i18n'
import { signupForm } from '@/features/Auth/forms/signup'

export const createPasswordResetForm = () => {
  const signup = signupForm()

  return createForm('passwordReset', {
    password: {
      ...signup.config.password,
      label: I18N.t('passwordReset.newPassword')
    },
    repeatPassword: {
      ...signup.config.repeatPassword,
      label: I18N.t('passwordReset.confirmNewPassword')
    }
  })
}

export const passwordReset = () => createPasswordResetForm()
